import { createGlobalStyle } from 'styled-components'
import { mq } from './mq'
import { theme } from './theme'

export const GlobalStyle = createGlobalStyle`
@font-face {
  font-family: "Skolar Sans PE condensed";
  src: url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-Rg_v1.woff2")
      format("woff2"),
    url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-Rg_v1.woff")
      format("woff");
  font-weight: 400;
  font-style: normal;
}
  
@font-face {
  font-family: "Skolar PE";
  src: url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Regular_v3.5.woff2") format("woff2"), url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Regular_v3.5.woff") format("woff");
  font-weight: 400;
  font-style: normal;
  }

  @font-face {
    font-family: "Skolar PE";
    src: url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Italic_v3.5.woff2") format("woff2"), url("https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarPE/SkolarLatnCyrl-Italic_v3.5.woff") format("woff");
    font-weight: 400;
    font-style: italic;
  }

:root {
  --text-color: ${theme.colors.text};
  --text-highlited: ${theme.colors.highlighted_text};
  --background-color: ${theme.colors.background};
};
* {
  box-sizing: border-box;
}

body, html {
  overscroll-behavior: none;
  scrollbar-width: none;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  min-height: 100svh;
}

html {
  font-size: 62.5%;
  width: 100%;
  height: 100%;
}

body {
  font-family: skolar-latin, serif;
  font-size: 1.6rem;
  width: 100%;
  height: 100%; 
  color: ${theme.colors.text};
  background-color: ${theme.colors.background};
}

#root {
  width: 100%;
  height: 100%;
  
  }
  h1, h2, h3 {
    font-family: "skolar-latin", serif;
    font-weight:800;
    font-style: italic;
  }
  h1 {
    font-size: 3.5rem;
    line-height: 4rem;
     ${mq.medium} {
      font-size: 5.6rem;
      line-height: 6.2rem;
    }
    ${mq.large} {
      font-size: 7.2rem;
      line-height: 7.8rem;
    }
    ${mq.xlarge} {
      font-size: 8rem;
      line-height: 8.7rem;
  }
  }
  h2{
    font-size: 3.5rem;
    ${mq.medium} {
      font-size: 5.6rem;
    }
    ${mq.large} {
      font-size: 6.4rem;
    }
    ${mq.xlarge} {
       font-size: 7.2rem;
    }
  }
  h3{
    font-size: 2.5rem;
     ${mq.medium} {
      font-size:3.6rem;
    }
     ${mq.large} {
      font-size:4.8rem;
    }
    ${mq.xlarge} {
      font-size: 5.6rem;
    }
  }
  p{
    font-family: "skolar-latin", serif;
    font-weight:400;
    font-size: 1.6rem;
    ${mq.medium} {
      font-size: 1.9rem;
    }
    ${mq.large} {
      font-size: 2.1rem;
    }
    ${mq.xlarge} {
      font-size: 2.4rem;
    }
    a{
      color: ${theme.colors.text}
    }
  }

  .fp-watermark {
    display: none;
  }
`
